import StripeService from "shared/services/StripeService"
// import { loadStripeTerminal } from "@stripe/terminal-js";
import {
    CREATE_STRIPE_PAYMENT_INTENT,
    CLEAR_STRIPE_PAYMENT_INTENT,
    REGISTER_STRIPE_READER,
    UPDATE_STRIPE_READER_STATUS
} from 'shared/actions/types'

let service = new StripeService();

export const updateReaderStatus = (status) => dispatch => {
    dispatch({
        type: UPDATE_STRIPE_READER_STATUS,
        payload: status
    });
}

export const createPaymentIntent = (accountId, params) => dispatch => {
    return service.collectPayment(accountId, params).then((result) => {
        dispatch({
            type: CREATE_STRIPE_PAYMENT_INTENT,
            payload: result
        });
        return Promise.resolve(result);
    })
}

export const processPaymentIntent = (accountId, params) => dispatch => {
    return service.processPayment(accountId, params).then((result) => {
        return Promise.resolve(result);
    })
}

export const registerStripeReader = (accountId, params) => dispatch => {
    return service.registerStripeReader(accountId, params).then((reader) => {
        dispatch({
            type: REGISTER_STRIPE_READER,
            payload: reader
        });
        return Promise.resolve(reader);
    })
}

export const cancelStripeReader = (accountId, params) => dispatch => {
    return service.cancelStripeReader(accountId, params).then((response) => {
        dispatch({
            type: CLEAR_STRIPE_PAYMENT_INTENT
        });
        return Promise.resolve(response);
    })
}
